export const BOOKS = "BOOKS";
export const MAILROOM = "MAILROOM";
export const LEGAL = "LEGAL";
export const INTERCO = "INTERCO";
export const RAISE = "RAISE";
export const SALES_TAX = "SALES_TAX";
export const TAX = "TAX";
